import type { Template } from "@/types";

export const PO_02_H0_V2: Template[] = [

    {
        id: "po-02-h0v2-01",
        name: "PO 01 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_01.png",
        size: [1217, 851],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 608, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 683, y: 79, width: 460, height: 694, rotation: 0, imageRotation: 0 }         
        ],
    },


    {
        id: "po-02-h0v2-02",
        name: "PO 02 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_02.png",
        size: [1217, 851],
        style: {},
        slots: [
            { id: "1", x: 74, y: 79, width: 460, height: 694, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 0, width: 608, height: 851, rotation: 0, imageRotation: 0 },
        ],
    },



{
    id: "po-02-h0v2-03",
    name: "PO 03 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 693, y: 81, width: 437, height: 689, rotation: 0, imageRotation: 0 },
            { id: "2", x: 85, y: 81, width: 437, height: 689, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-04",
    name: "PO 04 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 224, y: 127, width: 380, height: 600, rotation: 0, imageRotation: 0 },
            { id: "2", x: 613, y: 127, width: 380, height: 600, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-05",
    name: "PO 05 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 34, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 643, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-06",
    name: "PO 06 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 34, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 170, width: 324, height: 510, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-07",
    name: "PO 07 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 73, y: 60, width: 463, height: 730, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 170, width: 324, height: 510, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-08",
    name: "PO 08 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 115, y: 127, width: 380, height: 600, rotation: 0, imageRotation: 0 },
            { id: "2", x: 723, y: 127, width: 380, height: 600, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-09",
    name: "PO 09 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 643, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 143, y: 170, width: 324, height: 510, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-10",
    name: "PO 10 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 682, y: 60, width: 463, height: 730, rotation: 0, imageRotation: 0 },
            { id: "2", x: 143, y: 170, width: 324, height: 510, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-11",
    name: "PO 11 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_11.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 98, y: 100, width: 413, height: 650, rotation: 0, imageRotation: 0 },
            { id: "2", x: 707, y: 100, width: 413, height: 650, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h0v2-12",
    name: "PO 12 - H0V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h0_v2_12.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 34, y: 33, width: 540, height: 785, rotation: 0, imageRotation: 0 },
            { id: "2", x: 643, y: 33, width: 540, height: 785, rotation: 0, imageRotation: 0 }
    ],
}
];